import { RegistrationGiftBanner } from './registration-gift-banner/RegistrationGiftBanner'
import { EmailVerificationBanner } from './email-verification-banner/EmailVerificationBanner'
import { FeeImmunityBanner } from './fee-immunity-banner/FeeImmunityBanner'
import { DataMigrationBanner } from './data-migration-banner/DataMigrationBanner'

function TopBanners() {
  return (
    <>
      <DataMigrationBanner />
      <RegistrationGiftBanner />
      <EmailVerificationBanner />
      <FeeImmunityBanner />
    </>
  )
}

export { TopBanners }
